/**
 * Setup webpack public path
 * to enable lazy-including of
 * js chunks
 *
 */
/* global urls:true */

import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import 'html-duration-picker';
import './scripts/kpi-chart';
import { initializeKPIMeter } from './scripts/kpi-meter';
import { initializeNavMenu } from './scripts/nav';
import { initializeTableSorting } from './scripts/table-sort';
import { initializeOnclickFilters } from './scripts/onclick-filter';
import { initializeTableRowModal } from './scripts/full-data-popup';
import { initiateTableFilter } from './scripts/table-filter';
import './scripts/date-picker';
import './scripts/user-form';
import Plotly from 'plotly.js-dist-min';
window.jQuery = $;
window.$ = $;

$(() => {
	// Initialize tooltips and popovers
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
	const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
	const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));

	let creditrequestctas = document.querySelectorAll('.crm-cta');
	creditrequestctas.forEach((button) => {
		button.addEventListener('click', (e) => {
			const callInstanceId = button.getAttribute('data-acp-ciid');
			// Populate the hidden input field in the modal with the call instance ID
			document.getElementById('callInstanceId').value = callInstanceId;
		});
	});

	const exportBtn = document.getElementById('tableExportBtn');

	if (exportBtn) {
		exportBtn.addEventListener('click', function () {
			// Get current URL parameters to preserve filters
			const currentUrl = new URL(window.location.href);
			const params = new URLSearchParams(currentUrl.search);

			// Build export URL with current filters
			const exportUrl = `${window.location.pathname}export/?${params.toString()}`;

			// Trigger download
			window.location.href = exportUrl;
		});
	}


	const modalElement = document.getElementById('tcModal');
	if (modalElement) {
		const modal = new bootstrap.Modal(modalElement);
		if (modalElement.getAttribute('data-acp-new-login') === '1') {
			modal.show();
		}
	}


	initializeNavMenu();
	initializeKPIMeter();
	initializeTableRowModal();
	initializeOnclickFilters();
	initializeTableSorting();
	initiateTableFilter();

	const plotlyCharts = document.querySelector('#plotly-chart');
	if (plotlyCharts) {
		const charts = JSON.parse(plotlyCharts.dataset.charts);

		charts.forEach((fig, i) => {
			console.log(i);
			const div = document.createElement("div");
			div.id = `chart-${i}`;
			div.style.marginBottom = "20px";
			div.style.height = "75px";
			plotlyCharts.appendChild(div);

			Plotly.newPlot(div.id, fig.data, fig.layout, { 'displayModeBar': false });
		});
	}
});




window.copyToClipboard = function (thisElement) {
	const text = thisElement.innerText || thisElement.textContent;

	navigator.clipboard.writeText(text.trim()).then(function () {
		const toastNoti = document.getElementById('toastNoti');
		if (toastNoti) {
			const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastNoti)
			toastBootstrap.show()
		}
	}, function (err) {
		console.error('Could not copy text: ', err);
	});
};

window.removeFilter = function (filterKey) {
	if (filterKey == 'all') {
		window.location.href = window.location.pathname;
		return;
	}

	const urlParams = new URLSearchParams(window.location.search);
	urlParams.delete(filterKey);

	const newURL = window.location.pathname + '?' + urlParams.toString();
	window.location.href = newURL;
};